import React from 'react';
import { Panel } from './Panel';

interface NotFoundProps {
  children: React.ReactNode;
}

export const NotFound = (props: NotFoundProps) => {
  return (
    <div className="text-gray-700">
      <Panel>{props.children}</Panel>
    </div>
  );
};
